import styles from './styles.module.css';

/**
 * @param {{ currentValue: number, maxValue: number }} props
 * @returns {JSX.Element | null} Null when maxValue ≤ 0.
 */
export const ProgressBar = ({ currentValue, maxValue }) => {
	if (!maxValue || maxValue <= 0) return null;

	const percentage = Math.min(Math.max((currentValue / maxValue) * 100, 0), 100);

	return (
		<div className={styles.track}>
			<div
				data-testid="progress-fill"
				className={styles.fill}
				style={{ width: `${percentage}%` }}
			/>
		</div>
	);
};
